var _path, _ellipse, _g, _rect, _g2, _path2, _rect2, _rect3, _path3, _path4, _path5, _path6, _rect4, _rect5, _rect6, _path7, _path8, _path9, _path10, _path11, _ellipse2, _path12, _path13, _path14, _rect7, _rect8, _path15, _rect9, _rect10, _rect11, _path16, _g3, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 217,
    viewBox: "0 0 303 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.908 45.4185C286.52 44.8188 286.005 44.3103 285.397 43.9274C284.789 43.5446 284.103 43.2965 283.385 43.1999L261.921 40.3026L254.211 20.8881C253.945 20.2193 253.535 19.6174 253.008 19.1239C252.482 18.6304 251.851 18.2572 251.159 18.0298C242.695 15.2518 233.748 14.0919 224.796 14.6117C224.09 14.6505 223.398 14.8346 222.765 15.152C222.131 15.4694 221.571 15.9131 221.118 16.4545L207.186 33.1757L185.585 30.4326C184.884 30.3432 184.171 30.4 183.49 30.5993C182.808 30.7986 182.175 31.1359 181.631 31.5895C174.736 37.3319 168.992 44.2973 164.703 52.1153C164.352 52.7524 164.145 53.455 164.095 54.1745C164.045 54.8941 164.153 55.6136 164.413 56.2833L171.971 75.778L158.233 92.5429C157.773 93.1034 157.44 93.7532 157.255 94.4481C157.071 95.1429 157.04 95.8666 157.164 96.5699C158.671 105.138 161.88 113.305 166.608 120.604C166.996 121.204 167.511 121.712 168.119 122.095C168.727 122.478 169.413 122.726 170.131 122.823L191.595 125.72L199.307 145.14C199.573 145.809 199.983 146.411 200.51 146.904C201.037 147.398 201.668 147.771 202.359 147.998C210.823 150.776 219.77 151.936 228.722 151.417C229.428 151.378 230.12 151.194 230.753 150.876C231.387 150.559 231.948 150.115 232.4 149.574L246.339 132.817L267.94 135.56C268.794 135.667 269.665 135.554 270.468 135.232C270.984 135.028 271.463 134.745 271.889 134.391C278.782 128.651 284.528 121.69 288.821 113.877C289.172 113.24 289.38 112.537 289.43 111.818C289.48 111.098 289.372 110.379 289.112 109.709L281.554 90.2144L295.292 73.4495C295.752 72.889 296.085 72.2392 296.269 71.5443C296.454 70.8494 296.485 70.1258 296.36 69.4225C294.847 60.8642 291.635 52.7078 286.908 45.4185ZM235.852 106.128C231.184 107.967 226.087 108.408 221.207 107.395C216.327 106.383 211.883 103.962 208.435 100.438C204.988 96.9153 202.693 92.4484 201.841 87.6025C200.988 82.7565 201.617 77.7493 203.646 73.2139C205.676 68.6785 209.015 64.8187 213.243 62.1226C217.471 59.4265 222.396 58.0151 227.397 58.0669C232.397 58.1188 237.249 59.6316 241.337 62.414C245.425 65.1963 248.566 69.1234 250.364 73.6984C252.775 79.8334 252.6 86.6967 249.878 92.7785C247.157 98.8602 242.111 103.662 235.852 106.128Z",
    fill: "#364356"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.854,
    cy: 200.485,
    rx: 135.383,
    ry: 6.8404,
    fill: "url(#paint1_radial_6511_94102)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6511_94102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.596,
    y: 27.2715,
    width: 64.4681,
    height: 46.0869,
    rx: 4.3376,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.596 31.6091C109.596 29.2135 111.538 27.2715 113.934 27.2715H169.727C172.122 27.2715 174.064 29.2135 174.064 31.6091V38.1155H109.596V31.6091Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 165.396,
    y: 30.5254,
    width: 4.33399,
    height: 4.3376,
    rx: 2.16699,
    fill: "#FC680A"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 157.27,
    y: 30.5254,
    width: 4.33399,
    height: 4.3376,
    rx: 2.16699,
    fill: "#FC680A"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 149.144,
    y: 30.5254,
    width: 4.33399,
    height: 4.3376,
    rx: 2.16699,
    fill: "#FC680A"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 114.064,
    y: 42.7441,
    width: 9.75148,
    height: 2.1688,
    fill: "#1D4ED8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.93,
    y: 46.791,
    width: 9.75148,
    height: 2.1688,
    fill: "#ECF4F5",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.93,
    y: 53.2988,
    width: 9.75148,
    height: 2.1688,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 160.655,
    y: 42.7441,
    width: 9.75148,
    height: 2.1688,
    fill: "#1D4ED8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.521,
    y: 61.9727,
    width: 9.75148,
    height: 2.1688,
    fill: "#ECF4F5",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.932,
    y: 42.4531,
    width: 31.9632,
    height: 2.1688,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.932,
    y: 61.9727,
    width: 31.9632,
    height: 2.1688,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 126.932,
    y: 46.791,
    width: 16.7942,
    height: 2.1688,
    fill: "#1D4ED8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.932,
    y: 53.2988,
    width: 20.5864,
    height: 2.1688,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.932,
    y: 57.6348,
    width: 13.002,
    height: 2.1688,
    fill: "#ECF4F5",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.932,
    y: 66.3105,
    width: 13.002,
    height: 2.1688,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.894,
    y: 46.791,
    width: 16.7942,
    height: 2.1688,
    fill: "#ECF4F5",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.602,
    y: 53.2988,
    width: 21.1282,
    height: 2.1688,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.102,
    y: 57.6348,
    width: 13.002,
    height: 2.1688,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.101,
    y: 66.3105,
    width: 13.002,
    height: 2.1688,
    fill: "#ECF4F5",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.27,
    y: 57.6348,
    width: 13.002,
    height: 2.1688,
    fill: "#1E293B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109.097,
    y: 26.7713,
    width: 65.4646,
    height: 47.0835,
    rx: 4.83817,
    stroke: "#1E293B",
    strokeWidth: 0.996535
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6511_94102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.24,
    y: 49.2227,
    width: 63.8438,
    height: 4.56027,
    fill: "url(#paint2_linear_6511_94102)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0063 127.789C85.7502 127.393 85.4097 127.057 85.008 126.804C84.6064 126.551 84.1529 126.387 83.6785 126.323L69.4944 124.407L64.3974 111.58C64.222 111.139 63.9509 110.741 63.6027 110.415C63.2545 110.089 62.8376 109.842 62.3807 109.692C56.7869 107.856 50.8749 107.089 44.959 107.431C44.4926 107.457 44.0354 107.578 43.6169 107.788C43.1984 107.998 42.8278 108.291 42.529 108.648L33.324 119.693L19.0494 117.879C18.5865 117.82 18.1148 117.857 17.6648 117.989C17.2147 118.121 16.7963 118.343 16.4367 118.643C11.8811 122.436 8.08585 127.037 5.25267 132.201C5.0209 132.622 4.88376 133.086 4.85069 133.562C4.81762 134.037 4.88941 134.512 5.06111 134.955L10.0574 147.834L0.980799 158.908C0.677045 159.279 0.456815 159.708 0.335082 160.167C0.213349 160.626 0.192961 161.104 0.27531 161.569C1.27171 167.229 3.39312 172.625 6.51833 177.447C6.77444 177.843 7.1149 178.179 7.51657 178.432C7.91824 178.685 8.37171 178.849 8.84616 178.913L23.0302 180.829L28.1288 193.66C28.3041 194.102 28.5752 194.499 28.9234 194.825C29.2716 195.151 29.6886 195.398 30.1455 195.548C35.7393 197.384 41.6512 198.152 47.5671 197.809C48.0335 197.783 48.4907 197.662 48.9092 197.452C49.3278 197.243 49.6984 196.95 49.9971 196.592L59.2063 185.523L73.4809 187.337C74.0454 187.408 74.621 187.334 75.1517 187.121C75.4923 186.987 75.8094 186.799 76.0906 186.566C80.6452 182.774 84.4412 178.176 87.2776 173.015C87.5094 172.594 87.6465 172.13 87.6796 171.655C87.7127 171.18 87.6409 170.704 87.4692 170.262L82.4729 157.382L91.5495 146.308C91.8533 145.938 92.0735 145.509 92.1952 145.05C92.317 144.591 92.3373 144.113 92.255 143.648C91.2543 137.994 89.1311 132.605 86.0063 127.789ZM52.2738 167.891C49.1893 169.105 45.8217 169.396 42.5968 168.727C39.3719 168.057 36.4346 166.457 34.1562 164.129C31.8779 161.802 30.3609 158.85 29.7971 155.649C29.2333 152.447 29.648 149.14 30.9887 146.144C32.3294 143.148 34.536 140.598 37.3294 138.817C40.1228 137.037 43.3775 136.105 46.682 136.139C49.9865 136.174 53.1923 137.174 55.8941 139.012C58.5958 140.851 60.6722 143.446 61.8606 146.468C63.4542 150.521 63.3395 155.056 61.5416 159.073C59.7437 163.091 56.41 166.262 52.2738 167.891Z",
    fill: "url(#paint3_linear_6511_94102)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.0763,
    y: 52.6359,
    width: 174.776,
    height: 116.615,
    rx: 5.58264,
    fill: "#2D3344",
    stroke: "#475569",
    strokeWidth: 1.24059
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.8936,
    y: 59.459,
    width: 161.142,
    height: 102.969,
    rx: 1.24059,
    fill: "#272D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8936 60.6996C71.8936 60.0144 72.449 59.459 73.1341 59.459H231.795C232.48 59.459 233.036 60.0144 233.036 60.6996V74.346H71.8936V60.6996Z",
    fill: "#1E293B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.673 169.871H176.635L179.114 194.063H125.194L127.673 169.871Z",
    fill: "#28303F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.673 169.871H176.635L177.255 177.315H127.053L127.673 169.871Z",
    fill: "#1E293B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.658 189.72C114.658 186.98 116.88 184.758 119.621 184.758H185.309C188.049 184.758 190.271 186.98 190.271 189.72V194.062H114.658V189.72Z",
    fill: "#343B4E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 220.728,
    y: 64.5547,
    width: 4.95822,
    height: 4.96235,
    rx: 2.47911,
    fill: "#FFD04E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 211.058,
    y: 64.5547,
    width: 4.95822,
    height: 4.96235,
    rx: 2.47911,
    fill: "#FFD04E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 202.032,
    y: 64.5547,
    width: 4.95822,
    height: 4.96235,
    rx: 2.47911,
    fill: "#FFD04E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.375 110.423C183.312 110.103 183.181 109.801 182.991 109.536C182.801 109.272 182.556 109.052 182.273 108.891L173.82 104.067L173.786 94.5275C173.785 94.1989 173.713 93.8745 173.574 93.5767C173.436 93.2788 173.234 93.0146 172.984 92.8023C169.918 90.2052 166.386 88.2149 162.578 86.9373C162.278 86.8357 161.96 86.7981 161.645 86.8269C161.33 86.8558 161.024 86.9504 160.748 87.1048L152.221 91.8773L143.685 87.0962C143.408 86.941 143.102 86.8457 142.787 86.8163C142.471 86.787 142.152 86.8244 141.852 86.926C138.046 88.2118 134.519 90.2098 131.457 92.8137C131.207 93.0257 131.006 93.2894 130.868 93.5867C130.729 93.8841 130.657 94.2079 130.655 94.536L130.613 104.084L122.16 108.908C121.877 109.069 121.632 109.289 121.442 109.553C121.252 109.818 121.12 110.12 121.057 110.44C120.284 114.332 120.284 118.339 121.057 122.232C121.12 122.552 121.252 122.854 121.442 123.118C121.632 123.383 121.877 123.603 122.16 123.764L130.613 128.588L130.647 138.13C130.648 138.459 130.72 138.783 130.859 139.081C130.997 139.379 131.198 139.643 131.449 139.855C134.515 142.452 138.046 144.443 141.855 145.72C142.154 145.822 142.472 145.86 142.788 145.831C143.103 145.802 143.409 145.707 143.685 145.553L152.221 140.766L160.756 145.547C161.094 145.736 161.475 145.833 161.861 145.831C162.109 145.831 162.355 145.791 162.59 145.712C166.394 144.427 169.922 142.431 172.984 139.83C173.234 139.618 173.435 139.354 173.574 139.057C173.712 138.759 173.784 138.436 173.786 138.108L173.828 128.56L182.282 123.736C182.564 123.575 182.809 123.354 182.999 123.09C183.19 122.826 183.321 122.523 183.384 122.204C184.153 118.314 184.15 114.311 183.375 110.423ZM152.221 127.671C149.979 127.671 147.787 127.006 145.923 125.759C144.059 124.512 142.606 122.739 141.748 120.665C140.89 118.591 140.666 116.309 141.103 114.108C141.541 111.906 142.62 109.884 144.205 108.296C145.791 106.709 147.81 105.628 150.009 105.19C152.208 104.752 154.487 104.977 156.558 105.836C158.63 106.695 160.4 108.15 161.646 110.016C162.891 111.883 163.556 114.077 163.556 116.322C163.556 119.332 162.362 122.219 160.236 124.347C158.11 126.476 155.227 127.671 152.221 127.671Z",
    fill: "#FEAD05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210.569 91.7998C210.543 91.6653 210.488 91.5382 210.408 91.4269C210.328 91.3157 210.225 91.223 210.106 91.1552L206.556 89.1261L206.542 85.1131C206.541 84.9749 206.511 84.8385 206.453 84.7132C206.395 84.5879 206.31 84.4767 206.205 84.3874C204.917 83.2949 203.434 82.4577 201.835 81.9202C201.709 81.8775 201.575 81.8616 201.443 81.8738C201.31 81.8859 201.182 81.9257 201.066 81.9906L197.484 83.9983L193.9 81.9871C193.783 81.9218 193.655 81.8817 193.522 81.8693C193.39 81.857 193.256 81.8727 193.13 81.9154C191.531 82.4563 190.05 83.2968 188.764 84.3922C188.659 84.4814 188.575 84.5923 188.516 84.7174C188.458 84.8425 188.428 84.9787 188.427 85.1167L188.409 89.1332L184.859 91.1624C184.74 91.2302 184.637 91.3229 184.558 91.4341C184.478 91.5453 184.423 91.6725 184.396 91.8069C184.071 93.4444 184.071 95.1301 184.396 96.7676C184.423 96.9021 184.478 97.0292 184.558 97.1405C184.637 97.2517 184.74 97.3444 184.859 97.4122L188.409 99.4413L188.424 103.455C188.424 103.594 188.454 103.73 188.513 103.855C188.571 103.981 188.655 104.092 188.76 104.181C190.048 105.274 191.531 106.111 193.131 106.648C193.257 106.691 193.39 106.707 193.523 106.695C193.655 106.683 193.783 106.643 193.9 106.578L197.484 104.564L201.069 106.576C201.211 106.655 201.371 106.696 201.533 106.695C201.637 106.695 201.741 106.678 201.839 106.645C203.437 106.104 204.919 105.265 206.205 104.17C206.31 104.081 206.394 103.97 206.453 103.845C206.511 103.72 206.541 103.584 206.542 103.446L206.56 99.4294L210.11 97.4002C210.229 97.3324 210.332 97.2398 210.411 97.1285C210.491 97.0173 210.546 96.8901 210.573 96.7557C210.896 95.1195 210.895 93.4355 210.569 91.7998ZM197.484 99.0558C196.543 99.0558 195.622 98.7758 194.84 98.2511C194.057 97.7265 193.446 96.9808 193.086 96.1084C192.726 95.236 192.632 94.276 192.815 93.3499C192.999 92.4237 193.452 91.573 194.118 90.9053C194.784 90.2375 195.632 89.7828 196.556 89.5986C197.479 89.4144 198.436 89.5089 199.306 89.8703C200.176 90.2316 200.92 90.8436 201.443 91.6288C201.966 92.4139 202.245 93.337 202.245 94.2813C202.245 95.5476 201.744 96.762 200.851 97.6574C199.958 98.5528 198.747 99.0558 197.484 99.0558Z",
    fill: "#64748B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M201.975 139.852C201.957 139.765 201.922 139.682 201.87 139.61C201.818 139.537 201.751 139.477 201.673 139.433L199.361 138.114L199.352 135.506C199.352 135.416 199.332 135.327 199.294 135.246C199.256 135.164 199.201 135.092 199.133 135.034C198.294 134.324 197.328 133.78 196.287 133.43C196.205 133.402 196.118 133.392 196.032 133.4C195.946 133.408 195.862 133.434 195.786 133.476L193.454 134.781L191.12 133.474C191.044 133.431 190.961 133.405 190.874 133.397C190.788 133.389 190.701 133.399 190.619 133.427C189.578 133.779 188.613 134.325 187.776 135.037C187.708 135.095 187.652 135.167 187.615 135.248C187.577 135.33 187.557 135.418 187.557 135.508L187.545 138.119L185.233 139.438C185.156 139.482 185.089 139.542 185.037 139.614C184.985 139.687 184.949 139.769 184.932 139.857C184.72 140.921 184.72 142.017 184.932 143.081C184.949 143.168 184.985 143.251 185.037 143.323C185.089 143.396 185.156 143.456 185.233 143.5L187.545 144.819L187.554 147.428C187.555 147.518 187.574 147.607 187.612 147.688C187.65 147.77 187.705 147.842 187.774 147.9C188.612 148.61 189.578 149.154 190.619 149.504C190.701 149.531 190.788 149.542 190.875 149.534C190.961 149.526 191.044 149.5 191.12 149.458L193.454 148.149L195.789 149.456C195.881 149.508 195.985 149.535 196.091 149.534C196.159 149.534 196.226 149.523 196.29 149.501C197.331 149.15 198.295 148.604 199.133 147.893C199.201 147.835 199.256 147.763 199.294 147.682C199.332 147.6 199.352 147.512 199.352 147.422L199.364 144.811L201.676 143.492C201.753 143.448 201.82 143.388 201.872 143.316C201.924 143.243 201.96 143.161 201.977 143.073C202.187 142.01 202.187 140.915 201.975 139.852ZM193.454 144.568C192.841 144.568 192.242 144.386 191.732 144.045C191.222 143.704 190.825 143.22 190.59 142.653C190.356 142.086 190.294 141.462 190.414 140.86C190.534 140.258 190.829 139.705 191.262 139.271C191.696 138.837 192.248 138.541 192.85 138.421C193.451 138.301 194.074 138.363 194.641 138.598C195.207 138.833 195.691 139.23 196.032 139.741C196.373 140.251 196.554 140.851 196.554 141.465C196.554 142.288 196.228 143.077 195.646 143.659C195.065 144.241 194.277 144.568 193.454 144.568Z",
    fill: "#575C69"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M277.307 59.989C277.253 59.9066 277.182 59.8366 277.099 59.784C277.015 59.7314 276.921 59.6973 276.822 59.684L273.871 59.2856L272.811 56.6161C272.774 56.5241 272.718 56.4414 272.645 56.3735C272.573 56.3057 272.486 56.2543 272.391 56.2231C271.227 55.8411 269.997 55.6816 268.766 55.7531C268.669 55.7584 268.574 55.7837 268.487 55.8274C268.4 55.871 268.323 55.932 268.26 56.0065L266.345 58.3056L263.375 57.9285C263.278 57.9162 263.18 57.924 263.086 57.9514C262.993 57.9788 262.906 58.0252 262.831 58.0875C261.883 58.8771 261.093 59.8349 260.503 60.9098C260.455 60.9975 260.427 61.0941 260.42 61.193C260.413 61.2919 260.428 61.3909 260.463 61.483L261.503 64.1635L259.614 66.4687C259.55 66.5458 259.505 66.6351 259.479 66.7306C259.454 66.8262 259.45 66.9257 259.467 67.0224C259.674 68.2005 260.115 69.3235 260.765 70.3271C260.819 70.4096 260.889 70.4795 260.973 70.5321C261.057 70.5848 261.151 70.6189 261.25 70.6322L264.201 71.0306L265.261 73.7009C265.298 73.7928 265.354 73.8756 265.427 73.9434C265.499 74.0113 265.586 74.0626 265.681 74.0939C266.845 74.4758 268.075 74.6353 269.306 74.5639C269.403 74.5585 269.498 74.5332 269.585 74.4896C269.672 74.4459 269.75 74.3849 269.812 74.3105L271.728 72.0064L274.698 72.3835C274.816 72.3983 274.936 72.3827 275.046 72.3384C275.117 72.3105 275.183 72.2714 275.242 72.2229C276.189 71.4336 276.979 70.4764 277.57 69.4022C277.618 69.3145 277.647 69.2179 277.653 69.119C277.66 69.0201 277.645 68.9211 277.61 68.829L276.57 66.1485L278.459 63.8433C278.523 63.7663 278.568 63.6769 278.594 63.5814C278.619 63.4858 278.623 63.3863 278.606 63.2896C278.398 62.1128 277.957 60.9913 277.307 59.989ZM270.286 68.3367C269.644 68.5895 268.944 68.6502 268.273 68.5109C267.602 68.3716 266.991 68.0388 266.517 67.5543C266.043 67.0699 265.727 66.4557 265.61 65.7894C265.493 65.123 265.579 64.4345 265.858 63.8109C266.137 63.1873 266.596 62.6566 267.178 62.2859C267.759 61.9151 268.436 61.7211 269.124 61.7282C269.811 61.7353 270.478 61.9433 271.041 62.3259C271.603 62.7085 272.035 63.2485 272.282 63.8776C272.613 64.7211 272.589 65.6648 272.215 66.5011C271.841 67.3373 271.147 67.9976 270.286 68.3367Z",
    fill: "#2D3344"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.703 134.638C115.676 134.503 115.621 134.376 115.541 134.265C115.461 134.154 115.358 134.061 115.24 133.993L111.689 131.964L111.675 127.951C111.675 127.813 111.644 127.676 111.586 127.551C111.528 127.426 111.443 127.315 111.338 127.225C110.05 126.133 108.567 125.296 106.968 124.758C106.842 124.715 106.708 124.7 106.576 124.712C106.444 124.724 106.315 124.764 106.199 124.829L102.618 126.836L99.0329 124.825C98.9167 124.76 98.7881 124.72 98.6555 124.707C98.5228 124.695 98.3891 124.711 98.2629 124.753C96.6644 125.294 95.183 126.135 93.8973 127.23C93.7923 127.319 93.7078 127.43 93.6497 127.555C93.5915 127.68 93.5611 127.817 93.5605 127.955L93.5426 131.971L89.9923 134C89.8735 134.068 89.7707 134.161 89.6908 134.272C89.6109 134.383 89.5559 134.51 89.5293 134.645C89.2044 136.282 89.2044 137.968 89.5293 139.606C89.5559 139.74 89.6109 139.867 89.6908 139.978C89.7707 140.09 89.8735 140.182 89.9923 140.25L93.5426 142.279L93.5569 146.293C93.5573 146.432 93.5877 146.568 93.6458 146.693C93.704 146.819 93.7886 146.93 93.8937 147.019C95.1816 148.112 96.6647 148.949 98.2641 149.486C98.39 149.529 98.5235 149.545 98.6559 149.533C98.7884 149.521 98.9168 149.481 99.0329 149.416L102.618 147.402L106.203 149.413C106.344 149.493 106.504 149.534 106.667 149.533C106.771 149.533 106.874 149.516 106.973 149.483C108.571 148.942 110.052 148.102 111.338 147.008C111.443 146.919 111.528 146.808 111.586 146.683C111.644 146.558 111.674 146.422 111.675 146.284L111.693 142.267L115.243 140.238C115.362 140.17 115.465 140.078 115.545 139.966C115.625 139.855 115.68 139.728 115.706 139.594C116.029 137.957 116.028 136.273 115.703 134.638ZM102.618 141.894C101.676 141.894 100.756 141.614 99.9728 141.089C99.1899 140.564 98.5798 139.819 98.2194 138.946C97.8591 138.074 97.7648 137.114 97.9485 136.188C98.1322 135.262 98.5856 134.411 99.2514 133.743C99.9172 133.075 100.766 132.621 101.689 132.436C102.612 132.252 103.57 132.347 104.44 132.708C105.31 133.07 106.053 133.681 106.576 134.467C107.099 135.252 107.378 136.175 107.378 137.119C107.378 138.385 106.877 139.6 105.984 140.495C105.091 141.391 103.88 141.894 102.618 141.894Z",
    fill: "#374151"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.465,
    cy: 116.528,
    rx: 14.8747,
    ry: 14.887,
    fill: "#FEAD05"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.694 122.728L141.244 108.734H144.122L150.673 122.728H147.02L145.81 119.89H139.557L138.346 122.728H134.694ZM142.653 112.545L140.748 117.091H144.599L142.693 112.545H142.653Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.52 122.728V108.734H158.249C159.837 108.734 161.061 109.145 161.921 109.965C162.795 110.772 163.231 111.89 163.231 113.32C163.231 114.749 162.795 115.874 161.921 116.694C161.061 117.501 159.837 117.905 158.249 117.905H155.172V122.728H151.52ZM155.172 115.106H157.614C159.043 115.106 159.758 114.511 159.758 113.32C159.758 112.129 159.043 111.533 157.614 111.533H155.172V115.106Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M164.934 122.728V108.734H168.586V122.728H164.934Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9012,
    y: 46.0804,
    width: 74.8936,
    height: 53.865,
    rx: 5.53503,
    stroke: "#475569",
    strokeWidth: 1.14007
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4717,
    y: 46.6504,
    width: 73.7535,
    height: 52.7249,
    rx: 4.96235,
    fill: "#2D3344"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4717 51.6127C19.4717 48.8721 21.6934 46.6504 24.434 46.6504H88.2629C91.0035 46.6504 93.2252 48.8721 93.2252 51.6127V59.0563H19.4717V51.6127Z",
    fill: "#1E293B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 83.3086,
    y: 50.373,
    width: 4.95822,
    height: 4.96235,
    rx: 2.47911,
    fill: "#FFD04E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 74.0122,
    y: 50.373,
    width: 4.95822,
    height: 4.96235,
    rx: 2.47911,
    fill: "#FFD04E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 64.7158,
    y: 50.373,
    width: 4.95822,
    height: 4.96235,
    rx: 2.47911,
    fill: "#FFD04E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.489 75.1448C72.2512 68.9923 67.1504 64.0762 61.0082 64.0762C58.8716 64.0765 56.7772 64.6729 54.9595 65.7986C53.1419 66.9243 51.6727 68.5348 50.7164 70.4499C49.9216 72.0376 49.5061 73.7888 49.5026 75.5651C49.5067 75.835 49.409 76.0965 49.229 76.2973C49.049 76.4981 48.8 76.6234 48.5318 76.6482C48.3885 76.6584 48.2445 76.6389 48.1089 76.5909C47.9734 76.5429 47.8492 76.4673 47.7441 76.369C47.639 76.2707 47.5553 76.1517 47.4982 76.0194C47.4411 75.8872 47.4118 75.7446 47.4121 75.6005C47.411 74.1351 47.6466 72.6792 48.1098 71.2893C48.1403 71.2002 48.1463 71.1045 48.1271 71.0123C48.1079 70.92 48.0642 70.8347 48.0007 70.7653C47.9372 70.6958 47.8561 70.6448 47.7661 70.6177C47.6761 70.5905 47.5804 70.5882 47.4892 70.611C45.6781 71.0634 44.0697 72.1094 42.9195 73.5829C41.7693 75.0563 41.1432 76.8726 41.1406 78.7435C41.1406 83.3519 45.0276 87.1248 49.6333 87.1248H61.0004C62.5481 87.1231 64.0795 86.8086 65.5032 86.2001C66.9268 85.5915 68.2133 84.7014 69.2859 83.583C70.3584 82.4646 71.1948 81.1409 71.7452 79.691C72.2956 78.2411 72.5485 76.6949 72.489 75.1448ZM64.8756 80.5324L60.6946 84.723C60.5976 84.8204 60.4823 84.8977 60.3554 84.9504C60.2285 85.0032 60.0925 85.0303 59.9551 85.0303C59.8178 85.0303 59.6817 85.0032 59.5549 84.9504C59.428 84.8977 59.3127 84.8204 59.2156 84.723L55.0346 80.5324C54.8385 80.3358 54.7283 80.0692 54.7283 79.7912C54.7283 79.5131 54.8385 79.2465 55.0346 79.0499C55.2307 78.8533 55.4968 78.7429 55.7741 78.7429C56.0515 78.7429 56.3175 78.8533 56.5136 79.0499L58.9099 81.453V73.5052C58.9099 73.2273 59.02 72.9608 59.216 72.7643C59.412 72.5679 59.6779 72.4575 59.9551 72.4575C60.2323 72.4575 60.4982 72.5679 60.6942 72.7643C60.8903 72.9608 61.0004 73.2273 61.0004 73.5052V81.453L63.3966 79.0499C63.5927 78.8533 63.8588 78.7429 64.1361 78.7429C64.4135 78.7429 64.6795 78.8533 64.8756 79.0499C65.0718 79.2465 65.182 79.5131 65.182 79.7912C65.182 80.0692 65.0718 80.3358 64.8756 80.5324Z",
    fill: "#FEAD05"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6511_94102)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.132,
    y: 101.373,
    width: 73.7535,
    height: 52.7249,
    rx: 4.96499,
    fill: "#2D3344"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.133,
    y: 101.373,
    width: 73.7535,
    height: 52.7249,
    rx: 4.96235,
    fill: "#2D3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.133 106.335C216.133 103.595 218.355 101.373 221.095 101.373H284.924C287.665 101.373 289.886 103.595 289.886 106.335V113.779H216.133V106.335Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 280.039,
    y: 105.17,
    width: 4.95822,
    height: 4.96235,
    rx: 2.47911,
    fill: "#FFD04E"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 270.369,
    y: 105.17,
    width: 4.95822,
    height: 4.96235,
    rx: 2.47911,
    fill: "#FFD04E"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 261.343,
    y: 105.17,
    width: 4.95822,
    height: 4.96235,
    rx: 2.47911,
    fill: "#FFD04E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.091,
    y: 118.742,
    width: 11.156,
    height: 2.48117,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.091,
    y: 123.703,
    width: 11.156,
    height: 2.48117,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.091,
    y: 131.148,
    width: 11.156,
    height: 2.48117,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.392,
    y: 118.742,
    width: 11.156,
    height: 2.48117,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.392,
    y: 141.072,
    width: 11.156,
    height: 2.48117,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.965,
    y: 118.742,
    width: 36.5669,
    height: 2.48117,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.965,
    y: 141.072,
    width: 36.5669,
    height: 2.48117,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.965,
    y: 123.703,
    width: 19.2131,
    height: 2.48117,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.965,
    y: 131.148,
    width: 23.5515,
    height: 2.48117,
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.965,
    y: 136.109,
    width: 14.8747,
    height: 2.48117,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.965,
    y: 146.035,
    width: 14.8747,
    height: 2.48117,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.658,
    y: 123.703,
    width: 19.2131,
    height: 2.48117,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.757,
    y: 131.148,
    width: 24.1713,
    height: 2.48117,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.32,
    y: 136.109,
    width: 14.8747,
    height: 2.48117,
    fill: "#FEAD05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.32,
    y: 146.033,
    width: 14.8747,
    height: 2.48117,
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.673,
    y: 136.109,
    width: 14.8747,
    height: 2.48117,
    fill: "#1E293B"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 215.562,
    y: 100.803,
    width: 74.8936,
    height: 53.865,
    rx: 5.53503,
    stroke: "#475569",
    strokeWidth: 1.14007
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6511_94102",
    x: 106.25,
    y: 45.2324,
    width: 71.8242,
    height: 12.541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.99512,
    result: "effect1_foregroundBlur_6511_94102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6511_94102",
    x1: 288.321,
    y1: 12.0183,
    x2: 241.398,
    y2: 169.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3344"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6511_94102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.724 193.597) rotate(-90) scale(7.73617 153.108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E293B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6511_94102",
    x1: 141.952,
    y1: 41.9595,
    x2: 142.187,
    y2: 53.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3344",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6511_94102",
    x1: -37.7139,
    y1: 110.756,
    x2: 46.4904,
    y2: 201.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C4A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6511_94102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.596,
    y: 27.2695,
    width: 64.4681,
    height: 46.0869,
    rx: 4.33991,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6511_94102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.132,
    y: 101.373,
    width: 73.7535,
    height: 52.7249,
    rx: 4.96499,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIllustration);
export default __webpack_public_path__ + "static/media/api_illustration.49f1cd7ba4cad464dd3b8c2211f238fb.svg";
export { ForwardRef as ReactComponent };